import * as React from "react";
const SvgChevronrightG300 = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path stroke="#C8C8C8" strokeLinecap="round" strokeLinejoin="round" d="m7 4 5 5-5 5" />
  </svg>
);
export default SvgChevronrightG300;
